import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiName, apiBasePath } from 'assets/constants';
import { useSelector } from 'react-redux';
import { getMainAccountId } from 'store/account';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

export async function getAllBookmarks(mainAccountId: string) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/actionPlan/bookmarks`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ACTION_PLAN,
        domain: DOMAINS.ACTION_PLAN,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {
        mainAccountId,
      },
    },
  );
  return response?.result ?? [];
}
export const getAllBookmarksQuery = (mainAccountId: string | null) => ({
  queryKey: [apiName, 'bookmarks', mainAccountId],
  queryFn: () => !!mainAccountId && getAllBookmarks(mainAccountId),
  enabled: !!mainAccountId,
});

export const getAllBookmarksQueryNonSuspense = (
  mainAccountId: string | null,
) => ({
  queryKey: [apiName, 'bookmarks', mainAccountId],
  queryFn: () => getAllBookmarks(mainAccountId as string),
  enabled: !!mainAccountId,
});
const useAllBookmarks = () => {
  const mainAccountId = useSelector(getMainAccountId);
  const actionPlanItemQuery = useSuspenseQuery(
    getAllBookmarksQuery(mainAccountId),
  );
  return actionPlanItemQuery;
};

export const useAllBookmarksNonSuspense = () => {
  const mainAccountId = useSelector(getMainAccountId);
  return useQuery(getAllBookmarksQueryNonSuspense(mainAccountId));
};

export default useAllBookmarks;
